"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.number.constructor");
var _index = require("@/api/virtualSimulationClass/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var TOPIC_MAP = {
  1: "中国特色社会主义",
  2: "心理健康教育与职业生涯",
  3: "哲学与人生",
  4: "职业道德与法治",
  5: "毛泽东思想和中国特色社会主义理论体系概论",
  6: "思想道德与法治"
};
var _default = exports.default = {
  props: {
    num: {
      type: [String, Number],
      default: 1
    },
    courseName: {
      type: String,
      default: ""
    }
  },
  name: "SptCoordinatorList",
  data: function data() {
    return {
      onlineList: [],
      prizeList: []
    };
  },
  computed: {
    topicName: function topicName() {
      return this.courseName || TOPIC_MAP[Number(this.num)] || "";
    },
    isSecondary: function isSecondary() {
      return ["1", "2", "3", "4"].includes(String(this.num));
    }
  },
  watch: {
    num: {
      immediate: true,
      handler: function handler() {
        this.getCourseList();
      }
    },
    courseName: function courseName() {
      this.getCourseList();
    }
  },
  methods: {
    getCourseList: function () {
      var _getCourseList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, rows;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.onlineList = [];
              this.prizeList = [];
              if (this.topicName) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              _context.next = 2;
              return (0, _index.getReceptionList)({
                courseName: this.topicName,
                courseSource: "",
                pageNum: 1,
                pageSize: 100,
                projectLevel: "",
                provinceId: this.$store.getters.provinceId,
                courseType: "2",
                schoolId: "",
                majorName: "",
                isSpecial: true,
                showStatus: 1
              });
            case 2:
              res = _context.sent;
              rows = res.rows || [];
              this.prizeList = rows;
              this.onlineList = this.buildOnlineList(rows);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getCourseList() {
        return _getCourseList.apply(this, arguments);
      }
      return getCourseList;
    }(),
    buildOnlineList: function buildOnlineList(list) {
      return list.filter(function (item) {
        return item.courseImage || item.courseLink || item.freeLink;
      }).slice(0, 8);
    },
    levelClass: function levelClass(level) {
      if (level === "省级") return "leb1sj";
      if (level === "校级") return "leb1xh";
      return "";
    },
    openLink: function openLink(url) {
      if (!url) return;
      window.open(url);
    }
  }
};